import { SIDEBAR_DEFAULT_WIDTH } from './sidebarStorage';

/**
 * Высота шапки — токен приложения `--shell-header-height` (56 px). Mantine печатает её в `:root`: токен, объявленный
 * ниже корня (на `.app-shell`), там не виден — без запасного значения высота пустая и меню наезжает на шапку.
 */
export const HEADER_HEIGHT = 'var(--shell-header-height, 56px)';
export const NAVBAR_WIDTH_OPEN = SIDEBAR_DEFAULT_WIDTH;
export const NAVBAR_WIDTH_CLOSED = 64;
export const APP_SHELL_TRANSITION_DURATION = 180;
/** Задержка открытия временной панели при наведении на рейл. */
export const SIDEBAR_OVERLAY_OPEN_DELAY = 180;
/** Пауза перед закрытием временной панели после ухода курсора. */
export const SIDEBAR_OVERLAY_CLOSE_DELAY = 80;
/** Уже 1200 px закрепление меню недоступно: панель сворачивается в рейл, полное меню — только
 *  временной панелью поверх контента. Ширина окна — свойство среды, предпочтение не перезаписывается. */
export const SIDEBAR_COMPACT_QUERY = '(max-width: 1199px)';
/** Телефон: страница с телефонной раскладкой (`phoneLayout`) показывает меню в Drawer. */
export const SIDEBAR_PHONE_QUERY = '(max-width: 48em)';

/**
 * Атрибут зоны кнопки меню в шапке: наведение на неё держит временную панель открытой, нажатие не считается щелчком
 * мимо панели. Своя кнопка меню в шапке (`menuToggle={false}` у AppShell) помечается им или классом
 * `menu-toggle-button`.
 */
export const APP_SHELL_TOGGLE_ATTRIBUTE = 'data-app-shell-toggle';
export const APP_SHELL_TOGGLE_SELECTOR = `[${APP_SHELL_TOGGLE_ATTRIBUTE}], .menu-toggle-button`;
